<script>
	import { createEventDispatcher, onMount } from "svelte";

	// REPL: https://svelte.dev/repl/b0a901d9a15347bd95466150485e4a78?version=3.31.0
	import ProgressBarTime from "./ProgressBarTime.svelte";
	import Controls from "./Controls.svelte";

	export let id;
	export let url;
	export let title;
	export let artist;
	export let coverUrl;
	export let hideProgressBar = false;

	let dispatch = createEventDispatcher();

	let audioFile;
	let totalTrackTime;

	onMount(() => {
		audioFile = new Audio(url);
		audioFile.onloadedmetadata = () => {
			totalTrackTime = audioFile.duration;
			updateTime();
		};
	});

	export let totalTimeDisplay = "loading...";
	export let currTimeDisplay = "0:00:00";
	export let progress = 0;
	let trackTimer;

	const updateTime = () => {
		progress = audioFile.currentTime * (100 / totalTrackTime);

		let currHrs = Math.floor(audioFile.currentTime / 60 / 60);
		let currMins = Math.floor(audioFile.currentTime / 60);
		let currSecs = Math.floor(audioFile.currentTime - currMins * 60);

		let durHrs = Math.floor(totalTrackTime / 60 / 60);
		let durMins = Math.floor((totalTrackTime / 60) % 60);
		let durSecs = Math.floor(totalTrackTime - durHrs * 60 * 60 - durMins * 60);

		if (currSecs < 10) currSecs = `0${currSecs}`;
		if (durSecs < 10) durSecs = `0${durSecs}`;
		if (currMins < 10) currMins = `0${currMins}`;
		if (durMins < 10) durMins = `0${durMins}`;

		currTimeDisplay = `${currHrs}:${currMins}:${currSecs}`;
		totalTimeDisplay = `${durHrs}:${durMins}:${durSecs}`;

		if (audioFile.ended) {
			toggleTimeRunning();
			dispatch("end", { id: id });
		}
	};

	const toggleTimeRunning = () => {
		if (audioFile.ended || !isPlaying) {
			isPlaying = false;
			clearInterval(trackTimer);
		} else {
			trackTimer = setInterval(updateTime, 100);
		}
	};

	// Controls
	export let isPlaying = false;

	export const pauseAudio = (dispatchEvent = true) => {
		audioFile.pause();
		isPlaying = false;
		toggleTimeRunning();
		if (dispatchEvent) dispatch("pause", { id: id });
	};

	export const playAudio = (dispatchEvent = true) => {
		audioFile.play();
		isPlaying = true;
		toggleTimeRunning();
		if (dispatchEvent) dispatch("play", { id: id });

		navigator.mediaSession.metadata = new MediaMetadata({
			title: title,
			artist: artist,
			artwork: coverUrl ? [{ src: coverUrl, sizes: "96x96", type: "image/png" }] : null,
		});

		navigator.mediaSession.setActionHandler("play", () => {
			playPauseAudio();
		});
		navigator.mediaSession.setActionHandler("pause", () => playPauseAudio());
	};

	export const playPauseAudio = () => {
		if (audioFile.paused) {
			playAudio();
		} else {
			pauseAudio();
		}
	};
</script>

<div class="audio-snippet">
	{#if !hideProgressBar}
		<ProgressBarTime {currTimeDisplay} {totalTimeDisplay} {progress} />
	{/if}
	<Controls {isPlaying} on:playPause={playPauseAudio} />
</div>

<style>
	.audio-snippet {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
</style>
